import React from 'react';
import { View, Text, StyleSheet, Image, TouchableOpacity, Platform, ScrollView } from 'react-native';
import Colors from '../../../constants/Colors';
import CS from '../../../constants/Styles';
import { BackgroundGradient, Loader, Button, TextInputContainer, Validate, AddressPicker, Alert } from '../../../components';
import { InvitePreviewModal } from '../../../components/Projects';
import UserState from '../../../src/contexts/UserState';
import { MaterialIcons, FontAwesome5 } from '@expo/vector-icons';
import * as rtApi from '../../../components/Api';
import * as SMS from 'expo-sms';
import * as MailComposer from 'expo-mail-composer';
import { formatPhoneNumber } from '../../../utils/Functions';
import SelectBox from 'react-native-multi-selectbox';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useLinkTo } from '@react-navigation/native';
import Constants from 'expo-constants';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

const InviteScreen = ({ navigation, route }) => {
  const [user, setUser] = React.useContext(UserState);
  
  const [mobileNumberVerified, setMobileNumberVerified] = React.useState(false);
  const [showPreview, setShowPreview] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [alertOptions, setAlertOptions] = React.useState({});
  // const [inviteType, setInviteType] = React.useState(null);

  const [contractorCustomerText, setContractorCustomerText] = React.useState(user.isContractor ? 'customer' : 'contractor');
  const [contractorCustomerText2, setContractorCustomerText2] = React.useState(user.isContractor ? 'Customer' : 'Contractor');
  // const [buttonText, setButtonText] = React.useState(Platform.OS === 'web' ? `Invite your ${contractorCustomerText2}` : 'Let us reach out');
  // const [blurb, setBlurb] = React.useState(Platform.OS === 'web' ? `We'll invite your ${contractorCustomerText} by email or SMS to join your project. We will notify you once your ${contractorCustomerText} has joined the project.` : `Invite your ${contractorCustomerText} to join this project through an SMS message, email or let us contact them for you. We will notify you once your ${contractorCustomerText} has joined the project.`);

  // const contractorCustomerText = user.isContractor ? 'customer' : 'contractor';
  // const contractorCustomerText2 = user.isContractor ? 'Customer' : 'Contractor';
  // const buttonText = Platform.OS === 'web' ? `Invite your ${contractorCustomerText2}` : 'Let us reach out';
  // const blurb = Platform.OS === 'web' ? `We'll invite your ${contractorCustomerText} by email or SMS to join your project. We will notify you once your ${contractorCustomerText} has joined the project.` : `Invite your ${contractorCustomerText} to join this project through an SMS message, email or let us contact them for you. We will notify you once your ${contractorCustomerText} has joined the project.`;

  const insets = useSafeAreaInsets();
  const linkTo = useLinkTo();

  // invalid
  const defaultIsInvalid = {
    fullName: false,
    emailAddress: false,
    phoneNumber: false,
  };
  const [isInvalid, setIsInvalid] = React.useState(defaultIsInvalid);

  // disbaled
  const defaultDisabled = {
    project: false,
    projectName: false,
    projectAddress: false,
    businessName: false,
    fullName: false,
    emailAddress: false,
    phoneNumber: false,
    businessNumber: false,
    personalMessage: false,
  };
  const [disabled, setDisabled] = React.useState(defaultDisabled);

  // inputs for focus
  let textInputs = {
    projectName: React.useRef(null),
    projectAddress: React.useRef(null),
    businessName: React.useRef(null),
    fullName: React.useRef(null),
    emailAddress: React.useRef(null),
    phoneNumber: React.useRef(null),
    businessNumber: React.useRef(null),
    personalMessage: React.useRef(null),
  };

  const [projectName, setProjectName] = React.useState('');
  const [projectAddress, setProjectAddress] = React.useState('');
  const [businessName, setBusinessName] = React.useState('');
  const [fullName, setFullName] = React.useState('');
  const [emailAddress, setEmailAddress] = React.useState('');
  const [phoneNumber, setPhoneNumber] = React.useState('');
  const [businessNumber, setBusinessNumber] = React.useState('');
  const [personalMessage, setPersonalMessage] = React.useState('');
  const [selectedProject, setSelectedProject] = React.useState({});
  const [projects, setProjects] = React.useState([]);
  // const [gotProjects, setGotProjects] = React.useState(false);
  
  React.useEffect(() => {
    navigation.setOptions({
      title: `Invite your ${contractorCustomerText2}`,
    });
    getProjects();
    return () => rtApi.cancel();
  }, []);

  React.useEffect(() => {
    // Customer
    // Contractor
    // Project
    // Create
    // Quote
    console.log('route.params.inviteType: ', route.params?.inviteType);
    if(route.params.inviteType === 'Create'){
      setSelectedProject({});
      setProjectName('');
      setProjectAddress('');
      setBusinessName('');
      setFullName('');
      setEmailAddress('');
      setPhoneNumber('');
      setBusinessNumber('');
      setPersonalMessage('');
    }
  }, [route.params?.inviteType])

  React.useEffect(() => {
    console.log('route.params.name: ', route.params?.name);
    if(route.params.name){
      setFullName(route.params.name);
      setDisabled(prevState => { return { ...prevState, fullName: true } });
    }
  }, [route.params?.name]);

  React.useEffect(() => {
    console.log('route.params.email: ', route.params?.email);
    if(route.params.email){
      setEmailAddress(route.params.email);
      setDisabled(prevState => { return { ...prevState, emailAddress: true } });
    }
  }, [route.params?.email]);

  React.useEffect(() => {
    console.log('route.params.phone: ', route.params?.phone);
    if(route.params.phone){
      if(route.params.inviteType === 'Contractor'){
        setBusinessNumber(route.params.phone);
        setDisabled(prevState => { return { ...prevState, businessNumber: true } });
      }else if(route.params.inviteType === 'Customer'){
        setPhoneNumber(route.params.phone);
        setDisabled(prevState => { return { ...prevState, phoneNumber: true } });
      }
    }
  }, [route.params?.phone]);

  React.useEffect(() => {
    console.log('route.params.customerId: ', route.params?.customerId);
  }, [route.params?.customerId]);

  React.useEffect(() => {
    console.log('route.params.contractorId: ', route.params?.contractorId);
  }, [route.params?.contractorId]);

  React.useEffect(() => {
    console.log('route.params.title: ', route.params?.title, disabled);
    if (route.params.title){
      setProjectName(route.params.title);
      setDisabled(prevState => { return {...prevState, projectName: true}});
    }
  }, [route.params?.title]);

  React.useEffect(() => {
    console.log('useeffect disabled: ', disabled);
  }, [disabled]);

  React.useEffect(() => {
    console.log('route.params.address: ', route.params?.address);
    if (route.params?.address){
      setProjectAddress(route.params.address);
      setDisabled(prevState => { return { ...prevState, projectAddress: true } });
    }
  }, [route.params?.address]);

  React.useEffect(() => {
    console.log('route.params.companyname: ', route.params?.companyname);
    if (route.params?.companyname) {
      setBusinessName(route.params.companyname);
      setDisabled(prevState => { return { ...prevState, businessName: true } });
    }
  }, [route.params?.companyname]);

  React.useEffect(() => {
    console.log('projectAddress: ', projectAddress);
  }, [projectAddress]);

  React.useEffect(() => {
    console.log('route.params.role: ', route.params?.role)
    if (route.params?.role){
      setContractorCustomerText(route.params.role === 'contractor' ? 'customer' : 'contractor');
      setContractorCustomerText2(route.params.role === 'contractor' ? 'Customer' : 'Contractor');
    }
  }, [route.params?.role]);

  // React.useEffect(() => {
  //   console.log('contractorId: ', route.params?.contractorId);
  //   if(route.params?.contractorId){
  //     console.log('inviteType: ', route.params.contractorId === '0' ? 'Contractors' : 'Contractor');
  //     setInviteType(route.params.contractorId === '0' ? 'Contractors' : 'Contractor');
  //   }
  // }, [route.params?.contractorId]);

  React.useEffect(() => {
    console.log('route.params.projectId: ', route.params?.projectId);
  }, [route.params?.projectId]);

  React.useEffect(() => {
    // console.log('useEffect projects: ', gotProjects, projects);
    console.log('useEffect projects: ', projects);
    // if(gotProjects){
      preSelectProject();
    // }
  // }, [gotProjects]);
  }, [projects]);

  const getProjects = async () => {
    setLoading(true);
    rtApi.get(`agreements?invite=yes`)
    .then(data => {
      setLoading(false);
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      // setProjects([]);
      const proj = data.agreements.map(p => { return { id: p.id, item: p.title } });
      console.log('getProjects: ', proj);
      setProjects(proj);
      // setGotProjects(true);
    }).catch(err => {
      setLoading(false);
      console.log(err);
    }).finally(() => {
      setLoading(false);
    });
  }

  const preSelectProject = () => {
    console.log('pre select', route.params?.projectId, projects);
    if(route.params?.projectId){
      const p = projects.find(project => { return project.id == route.params.projectId});
      setSelectedProject(p || {});
      setDisabled(prevState => { return { ...prevState, project: true } });
    }
  }

  const onChangeProjectName = (t) => {
    if (isInvalid.projectName && Validate.Name(t)) {
      setIsInvalid(prevState => { return { ...prevState, projectName: false } });
    }
    setProjectName(t);
  };
  const onChangeBusinessName = (t) => {
    setBusinessName(t);
  };
  const onChangeFullName = (t) => {
    if (isInvalid.fullName && Validate.Name(t)) {
      setIsInvalid(prevState => { return { ...prevState, fullName: false } });
    }
    setFullName(t);
  };
  const onChangeEmailAddress = (t) => {
    if (isInvalid.emailAddress && Validate.Email(t)) {
      setIsInvalid(prevState => { return { ...prevState, emailAddress: false } });
    }
    setEmailAddress(t.trim());
  };
  const onChangePhoneNumber = (n) => {
    n = formatPhoneNumber(n);
    if (isInvalid.phoneNumber && Validate.PhoneNumber(n)) {
      setIsInvalid(prevState => { return { ...prevState, phoneNumber: false } });
    }
    setPhoneNumber(n.trim());
  };
  const onChangeBusinessNumber = (n) => {
    n = formatPhoneNumber(n);
    if (isInvalid.businessNumber && Validate.PhoneNumber(n)) {
      setIsInvalid(prevState => { return { ...prevState, businessNumber: false } });
    }
    setBusinessNumber(n.trim());
  };
  const onChangePersonalMessage = (t) => {
    if (isInvalid.personalMessage && Validate.Blank(t)) {
      setIsInvalid(prevState => { return { ...prevState, personalMessage: false } });
    }
    setPersonalMessage(t);
  };

  const checkSMS = () => {
    console.log('checkSMS');
    if (!Validate.Name(fullName)) {
      setIsInvalid(prevState => { return { ...prevState, fullName: true } });
      textInputs.fullName.current.focus();
      // Alert.alert('Error', 'Full name required');
      return false;
    }
    if (!Validate.PhoneNumber(phoneNumber)) {
      setIsInvalid(prevState => { return { ...prevState, phoneNumber: true } });
      textInputs.phoneNumber.current.focus();
      // Alert.alert('Error', 'Phone number required');
      return false;
    }
    return true;
  }
  const checkEmail = () => {
    console.log('checkEmaik');
    if (!Validate.Name(fullName)) {
      setIsInvalid(prevState => { return { ...prevState, fullName: true } });
      textInputs.fullName.current.focus();
      // Alert.alert('Error', 'Full name required');
      return false;
    }
    if (!Validate.Email(emailAddress)) {
      setIsInvalid(prevState => { return { ...prevState, emailAddress: true } });
      textInputs.emailAddress.current.focus();
      // Alert.alert('Error', 'Email address required');
      return false;
    }
    return true;
  }
  const check = async () => {
    console.log('check');
    if(phoneNumber && Validate.PhoneNumber(phoneNumber)){
      try{
        let verifyResult = await verifyMobileNumber();
      }catch(err){
        console.log('catch err: ', err);
        return false;
      } 
    }
    if(route.params.inviteType === 'Project'){
      if (!Validate.Name(fullName)) {
        setIsInvalid(prevState => { return { ...prevState, fullName: true } });
        textInputs.fullName.current.focus();
        return false;
      }
      if (!Validate.Email(emailAddress) && !Validate.PhoneNumber(phoneNumber)) {
        setIsInvalid(prevState => { return { ...prevState, emailAddress: true } });
        setIsInvalid(prevState => { return { ...prevState, phoneNumber: true } });
        // textInputs.emailAddress.current.focus();
        setAlertOptions({ visible: true, title: 'Error', message: 'Email address or phone number are required', });
        return false;
      }
    } else if (route.params.inviteType === 'Contractor' || route.params.inviteType === 'Customer'){
      if(!selectedProject?.id){
        setAlertOptions({ visible: true, title: 'Error', message: `You must select an existing project to invite your ${contractorCustomerText}`, });
        return false;
      }
    } else if (route.params.inviteType === 'Create') {
      if (!Validate.Blank(projectName)) {
        setIsInvalid(prevState => { return { ...prevState, projectName: true } });
        textInputs.projectName.current.focus();
        return false;
      }
      if (!Validate.Blank(projectAddress)) {
        setIsInvalid(prevState => { return { ...prevState, projectAddress: true } });
        textInputs.projectAddress.current.focus();
        return false;
      }
      if (!Validate.Name(fullName)) {
        setIsInvalid(prevState => { return { ...prevState, fullName: true } });
        textInputs.fullName.current.focus();
        return false;
      }
      if (!Validate.Email(emailAddress) && !Validate.PhoneNumber(phoneNumber)) {
        setIsInvalid(prevState => { return { ...prevState, emailAddress: true } });
        setIsInvalid(prevState => { return { ...prevState, phoneNumber: true } });
        // textInputs.emailAddress.current.focus();
        setAlertOptions({ visible: true, title: 'Error', message: 'Email address or phone number are required', });
        return false;
      }
    } else if (route.params.inviteType === 'Quote') {
      if (!Validate.Name(fullName)) {
        setIsInvalid(prevState => { return { ...prevState, fullName: true } });
        textInputs.fullName.current.focus();
        return false;
      }
      if (!Validate.Email(emailAddress)) {
        setIsInvalid(prevState => { return { ...prevState, emailAddress: true } });
        textInputs.emailAddress.current.focus();
        // setAlertOptions({ visible: true, title: 'Error', message: 'Email address or phone number are required', });
        return false;
      }
    }
    
    return true;
  }
  const verifyMobileNumber = () => {
    setLoading(true);
    console.log('verifyMobileNumber');
    return new Promise((resolve, reject) => {
      // setTimeout(() => {
      //   setMobileNumberVerified(true);
      //   setLoading(false);
      //   resolve(true);
      // }, 1000);
      rtApi.get(`invite/validate_mobile_number/${phoneNumber}`)
      .then(data => {
        if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
        console.log('invite/validate_mobile_number/:phone_number', data);
        if (data.result) {
          if(data.valid){
            setMobileNumberVerified(data.valid);
            resolve(true);
          }else{
            setAlertOptions({
              visible: true,
              title: 'Error',
              message: `The Mobile Phone Number you entered cannot receive SMS messages. Please ensure you have entered a valid mobile phone number in order for your invitation to be received by your ${route.params.role === 'homeowner' ? 'contractor' : 'homeowner'}.`,
              buttons: [
                {
                  text: 'OK',
                  onPress: () => {
                    reject(false);
                    textInputs.phoneNumber.current.focus();
                  }
                }
              ]
            });
            // reject(false);
          }
        }
      }).catch(err => {
        console.log('err: ', err);
        reject(false);
      }).finally(() => {
        setLoading(false);
      });
    });
  }
  // const submit = () => {
  //   if (!check()) { return; }
  //   setLoading(true);
  //   let fd = buildFormData();
  //   rtApi.post(`agreements/${route.params.projectId}/invite`, fd)
  //     .then(data => {
  //       if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
  //       console.log('invite post', data);
  //       navigation.navigate('Invite3', {
  //         projectId: route.params.projectId,
  //       });
  //     }).catch(err => {

  //     }).finally(() => {
  //       setLoading(false);
  //     });
  // }
  const buildFormData = () => {
    let fd = new FormData();
    fd.append('full_name', fullName);
    if (emailAddress) fd.append('email_address', emailAddress);
    if (phoneNumber) fd.append('phone_number', phoneNumber);
    if(selectedProject?.id) fd.append('project_id', selectedProject.id);
    if(projectName) fd.append('project_name', projectName);
    if(projectAddress) fd.append('project_address', projectAddress);
    if(businessName) fd.append('business_name', businessName);
    if(businessNumber) fd.append('business_number', businessNumber);
    if (personalMessage) fd.append('personal_message', personalMessage);
    if(route.params?.contractorId) fd.append('contractor_id', route.params.contractorId);
    if (route.params?.customerId) fd.append('customer_id', route.params.customerId);
    return fd;
  }

  const letUsReachOut = async () => {
    // if (!check()) { return; }
    setShowPreview(false);
    setLoading(true);
    try{
      let inviteResult = await smsEmail('reachOut');
      console.log('inviteResult: ', inviteResult);
      if (inviteResult.result) {
        afterReachOut();
      }
      setLoading(false);
    }catch(err) {
      console.log('invite catch: ', err);
      setLoading(false);
    }
    
  }
  const afterReachOut = () => {
    console.log('after let us reach out: ', route.params);
    // let options = {
    //   inviteType: route.params.inviteType,
    // };
    // if (route.params.inviteType === 'Project'){
    //   options.projectId = route.params.projectId;
    // }
    // navigation.navigate('InviteSuccess', options);
    switch (route.params.inviteType) {
      // case 'Customers':
      //   linkTo(`/customer/0/invite/success?inviteType=Customers`);
      //   return;
      // case 'Contractors':
      //   linkTo(`/contractor/0/invite/success?inviteType=Contractors`);
      //   return;
      case 'Customer':
        linkTo(`/customer/${route.params.customerId}/invite/success?inviteType=Customer&customerId=${route.params.customerId}`);
        return;
      case 'Contractor':
        linkTo(`/contractor/${route.params.contractorId}/invite/success?inviteType=Contractor&contractorId=${route.params.contractorId}`);
        return;
      case 'Project':
        linkTo(`/project/${route.params.projectId}/invite/success?inviteType=Project&projectId=${route.params.projectId}`);
        return;
      case 'Create':
        linkTo(`/project/0/invite/success?inviteType=Create`);
        return;
      case 'Quote':
        linkTo(`/project/${route.params.projectId}/invite/success?inviteType=Quote&projectId=${route.params.projectId}`);
    }
  }

  // const sms = async () => {
  //   console.log('sms');
  //   if (!checkSMS()) { return; }
  //   setLoading(true);
  //   const isAvailable = await SMS.isAvailableAsync();
  //   if (isAvailable) {
  //     // do your SMS stuff here
  //     let { sms } = await smsEmail('sms');
  //     console.log('smsMessage', sms);
  //     const { result } = await SMS.sendSMSAsync(
  //       [phoneNumber],
  //       sms,
  //     );
  //     if((Platform.OS === 'ios' && result === 'sent') || (Platform.OS === 'android' && result === 'unknown')){
  //       // Alert.alert('Success', `Your SMS has been successfully sent to the ${contractorCustomerText}`);
  //       afterSmsEmail();
  //     }
  //     setLoading(false);
  //   } else {
  //     setLoading(false);
  //     // misfortune... there's no SMS available on this device
  //     setTimeout(() => {
  //       setAlertOptions({ visible: true, title: 'Error', message: 'SMS is unavailable on your device', });
  //     }, 100);
  //   }
  // }
  // const afterSmsEmail = () => {
  //   if(route.params.inviteType === 'Project'){
  //     let fd = new FormData();
  //     fd.append('stage', 'Invite Sent');
  //     rtApi.put(`agreements/${route.params.projectId}`, fd)
  //       .then(data => {
  //         if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
  //         setLoading(false);
  //         // navigation.navigate('Project', {
  //         //   projectId: route.params.projectId,
  //         //   sentInvitation: true,
  //         // });
  //         // linkTo(`/project/${route.params.projectId}/?sentInvitation=yes`)
  //         linkTo(`/projects`)
  //       });
  //   }else if(route.params.inviteType === 'Customer'){
  //     linkTo(`/customer/${route.params.customerId}`);
  //     // navigation.navigate('Customer', {
  //     //   customerId: route.params.id,
  //     // });
  //   } else if(route.params.inviteType === 'Contractor'){
  //     linkTo(`/contrator/${route.parms.contractorId}`);
  //     // navigation.navigate('Contractor', {
  //     //   companyId: route.params.id,
  //     // });
  //   }
  // }
  // const email = async () => {
  //   console.log('email()');
  //   if (!checkEmail()) { return; }
  //   setLoading(true);
  //   const isAvailable = await MailComposer.isAvailableAsync();
  //   if(isAvailable){
  //     let { email_subject, email_body } = await smsEmail('email');
  //     const { status } = await MailComposer.composeAsync({
  //       recipients: [emailAddress],
  //       subject: email_subject,
  //       body: email_body,
  //       // body: "test <a href='www.google.com'>Google</a>",
  //       isHtml: true,
  //     });
  //     console.log('status: ', status);
  //     if (status === 'sent' || Platform.OS === 'web') {
  //       // Alert.alert('Success', `Your Email has been successfully sent to the ${contractorCustomerText}`);
  //       afterSmsEmail();
  //     }
  //     setLoading(false);
  //   }else{
  //     setLoading(false);
  //     setTimeout(() => {
  //       setAlertOptions({ visible: true, title: 'Error', message: 'Mail is unavailable on your device', });
  //     }, 100);
  //   }
  // }
  // const afterEmail = () => {
  //   if(route.params.inviteType === 'Project'){
  //     let fd = new FormData();
  //     fd.append('stage', 'Invite Sent');
  //     rtApi.put(`agreements/${route.params.projectId}`, fd)
  //     .then(data => {
  //       setLoading(false);
  //       if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
  //       navigation.navigate('Project', {
  //         projectId: route.params.projectId,
  //         sentInvitation: true,
  //       });
  //     });
  //   } else if (route.params.inviteType === 'Customer') {
  //     navigation.navigate('Customer', {
  //       customerId: route.params.id,
  //     });
  //   } else if (route.params.inviteType === 'Contractor') {
  //     navigation.navigate('Contractor', {
  //       companyId: route.params.id,
  //     });
  //   }
  // }
  const smsEmail = (type) => {
    console.log('smsEmail', route.params.projectId);
    console.log('inviteType', route.params.inviteType);
    // return;
    let fd = buildFormData();
    if(type === 'reachOut'){
      fd.append('renovationtrust_send', true);
    }
    let url = '';
    if(route.params.inviteType === 'Project'){
      url = `agreements/${route.params.projectId}/invite`;
    } else if (route.params.inviteType === 'Customer' || route.params.inviteType === 'Contractor') {
      url = `agreements/${selectedProject.id}/invite`;
    }else if(route.params.inviteType === 'Create'){
      url = 'invite/create';
    } else if (route.params.inviteType === 'Quote') {
      url = `agreements/${route.params.projectId}/quote`;
    }
    // url = `test${url}`;
    return new Promise((resolve, reject) => {
      rtApi.post(url, fd)
      .then(data => {
        if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
        console.log('saved project from invite', data);
        if(data.result){
          resolve(data);
        }
        reject(data);
      }).catch(err => {
        reject(err);
      });
    });
  }

  const selectProject = (p) => {
    console.log('selectProject: ', p);
    setSelectedProject(p);
  }

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      switch(route.params.inviteType){
        case 'Customers':
          linkTo(`/customers`);
          return;
        case 'Contractors':
          linkTo(`/contractors`);
          return;
        case 'Customer':
          linkTo(`/customer/${route.params.customerId}`);
          return;
        case 'Contractor':
          linkTo(`/contractor/${route.params.contractorId}`);
          return;
        case 'Project':
          linkTo(`/project/${route.params.projectId}`);
          return;
      } 
    }
  }

  const setIsInvalidAddress = () => {
    setIsInvalid(prevState => { return { ...prevState, projectAddress: false } });
  }

  const cancelPreview = () => {
    setShowPreview(false);
  }

  const previewInvitation = async () => {
    const result = await check();
    if (!result) { return; }
    setShowPreview(true);
  }

  const renderTopBlurb = (inviteType) => {
    switch(inviteType){
      case 'Create':
        return <Text style={[CS.smallText, CS.lightText, CS.italicText]}>{`We'll invite your ${contractorCustomerText} by email or SMS to create your project. We will notify you once your ${contractorCustomerText} has created the project and invited you.`}</Text>
      case 'Customer':
      case 'Contractor':
      case 'Project':
        return <Text style={[CS.smallText, CS.lightText, CS.italicText]}>{`We'll invite your ${contractorCustomerText} by email or SMS to join your project. We will notify you once your ${contractorCustomerText} has joined the project.`}</Text>
      case 'Quote':
        return <Text style={[CS.smallText, CS.lightText, CS.italicText]}>{`We'll invite your ${contractorCustomerText} by email to quote your project.`}</Text>
    }
  }

  const renderBottomBlurb = (inviteType) => {
    switch (inviteType) {
      case 'Quote':
        return <Text style={[CS.smallText, CS.lightText, CS.italicText, { marginBottom: 20 }]}>You must enter the invitees first and last name as well as their email address to continue.</Text>
      default:
        return <Text style={[CS.smallText, CS.lightText, CS.italicText, { marginBottom: 20 }]}>You must enter the invitees first and last name as well as their email address or mobile phone number to continue.</Text>
      }
  }

  const onSubmitEditing = (field) => {
    console.log('onSubmitEditing: ', field);
    if(field === 'emailAddress'){
      if(route.params.inviteType === 'Quote'){
        textInputs.businessNumber.current.focus();
      }else{
        textInputs.phoneNumber.current.focus();
      }
    }else if(field === 'phoneNumber'){
      if(route.params.inviteType === 'Contractor'){
        previewInvitation();
      }else{
        textInputs.businessNumber.current.focus();
      }
    }
  }

  return (
    <View style={[CS.container]}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      <InvitePreviewModal
        show={showPreview}
        // show={true}
        setShow={setShowPreview}
        cancel={cancelPreview}
        send={letUsReachOut}
        toName={fullName}
        address={projectAddress}
        projectName={projectName}
        emailAddress={emailAddress}
        phoneNumber={phoneNumber}
        personalMessage={personalMessage}
        inviteType={route.params.inviteType}
        role={route.params.role}
        email={emailAddress ? true : false}
        sms={mobileNumberVerified}
      />
      {/* <ScrollView keyboardShouldPersistTaps='handled' style={styles.scrollView} contentContainerStyle={[styles.innerContainer, { paddingTop: insets.top }]} keyboardDismissMode='on-drag'> */}
      <KeyboardAwareScrollView keyboardShouldPersistTaps='handled' style={styles.scrollView} contentContainerStyle={[styles.innerContainer, { paddingTop: insets.top }]} keyboardDismissMode='on-drag'>
        <TouchableOpacity onPress={goBack} style={{ marginTop: 10, marginBottom: 20, justifyContent: 'center' }}>
          <FontAwesome5 name="arrow-left" size={24} color="white" style={{ position: 'absolute' }} />
          <Text style={[CS.mediumTitle, CS.lightText, CS.centerText, { marginVertical: 0 }]}>Invite your {contractorCustomerText2}</Text>
        </TouchableOpacity>
        <View style={{ marginVertical: 20 }}>
          {/* { === 'Create' ?
            <Text style={[CS.smallText, CS.lightText, CS.italicText]}>{Platform.OS === 'web' ? `We'll invite your ${contractorCustomerText} by email or SMS to create your project. We will notify you once your ${contractorCustomerText} has created the project and invited you.` : `Invite your ${contractorCustomerText} to create your project through an SMS message, email or let us contact them for you. We will notify you once your ${contractorCustomerText} has created the project and invited you.`}</Text>
            :
            <Text style={[CS.smallText, CS.lightText, CS.italicText]}>{Platform.OS === 'web' ? `We'll invite your ${contractorCustomerText} by email or SMS to join your project. We will notify you once your ${contractorCustomerText} has joined the project.` : `Invite your ${contractorCustomerText} to join this project through an SMS message, email or let us contact them for you. We will notify you once your ${contractorCustomerText} has joined the project.`}</Text>
          } */}
          {renderTopBlurb(route.params.inviteType)}
        </View>
        <View>
          {/* {(route.params.inviteType === 'Customer' || route.params.inviteType === 'Contractor') ? */}
          {(route.params.inviteType === 'Customer' || route.params.inviteType === 'Contractor') ?
            <View style={{ marginBottom: 20 }}>
              <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Project</Text>
              <SelectBox
                label="Select a Project"
                options={projects}
                value={selectedProject}
                onChange={selectProject}
                hideInputFilter={true}
                arrowIconColor={Colors.lightGrey}
                labelStyle={{ display: 'none', }}
                optionsLabelStyle={{ color: Colors.lightText, padding: 8, backgroundColor: Colors.textInputBackground }}
                selectedItemStyle={{ color: Colors.lightText }}
                containerStyle={{ borderWidth: 1, borderRadius: 10, backgroundColor: Colors.textInputBackground, padding: 8, height: 44, borderColor: Colors.lightBlue, alignItems: 'center' }}
                optionContainerStyle={{ borderWidth: 1, borderColor: Colors.lightBlue, padding: 0, paddingVertical: 0, paddingRight: 0, backgroundColor: Colors.textInputBackground, borderRadius: 0, width: '96%', marginLeft: '2%', flexDirection: 'column', alignItems: 'stretch' }}
                listEmptyLabelStyle={{ color: Colors.lightText, }}
                disabled={disabled.project}
              /> 
            </View>
            : null 
          }
          {(route.params.inviteType === 'Project' || route.params.inviteType === 'Create' || route.params.inviteType === 'Quote') ?
            <>
              <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Project Name</Text>
              <TextInputContainer
                iconName='pencil'
                placeholder='Project Name'
                onChangeText={(t) => onChangeProjectName(t)}
                inputRef={textInputs.projectName}
                isInvalid={isInvalid.projectName}
                autoCapitalize='none'
                onSubmitEditing={() => textInputs.projectAddress.current.focus()}
                returnKeyType='next'
                value={projectName}
                editable={!disabled.projectName}
              />
            </>
          : null}
          {/* {(route.params.inviteType === 'Project' || route.params.inviteType === 'Create' || route.params.inviteType === 'Quote') ? */}
          {['Project', 'Create', 'Quote'].includes(route.params.inviteType) &&
            <>
              <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Project Address</Text>
              {route?.params?.address
              ?
                <TextInputContainer
                  iconName='home'
                  placeholder='Project Address'
                  // onChangeText={(t) => onChangeProjectName(t)}
                  // inputRef={textInputs.projectName}
                  // isInvalid={isInvalid.projectName}
                  // autoCapitalize='none'
                  // onSubmitEditing={() => textInputs.address.current.focus()}
                  // returnKeyType='next'
                  value={projectAddress}
                  editable={false}
                />
              :
                <AddressPicker
                  placeholder={Platform.OS === 'web' ? '10-1000 Main St. Toronto, ON' : 'Where is the project located?'}
                  innerPlaceholder='10-1000 Main St. Toronto, ON'
                  value={projectAddress}
                  setAddress={setProjectAddress}
                  offsetTop={Constants.statusBarHeight}
                  // outerInputContainerStyle={styles.marginContainer}
                  inputRef={textInputs.projectAddress}
                  isInvalid={isInvalid.projectAddress}
                  setIsInvalid={setIsInvalidAddress}
                  editable={!disabled.projectAddress}
                />
              }
            </>
          }

          {route.params.inviteType === 'Contractor' || route.params.inviteType === 'Quote' || ((route.params.inviteType === 'Create' || route.params.inviteType === 'Project') && route.params.role === 'homeowner') ?
            <>
              <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Contractor's Business Name (Optional)</Text>
              <TextInputContainer
                iconName='wrench'
                placeholder='Business Name'
                onChangeText={(t) => onChangeBusinessName(t)}
                inputRef={textInputs.businessName}
                isInvalid={isInvalid.businessName}
                autoCapitalize='none'
                onSubmitEditing={() => textInputs.fullName.current.focus()}
                returnKeyType='next'
                value={businessName}
                editable={!disabled.businessName}
              />
            </>
          : null}
          
          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>{contractorCustomerText2}'s First and Last Name</Text>
          <TextInputContainer
            iconName='user'
            placeholder={`${contractorCustomerText2} Name`}
            onChangeText={(t) => onChangeFullName(t)}
            inputRef={textInputs.fullName}
            isInvalid={isInvalid.fullName}
            autoCapitalize='words'
            onSubmitEditing={() => textInputs.emailAddress.current.focus()}
            returnKeyType='next'
            value={fullName}
            editable={!disabled.fullName}
          />
          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>{contractorCustomerText2}'s Email Address</Text>
          <TextInputContainer
            iconName='envelope'
            placeholder={`${contractorCustomerText2} Email Address`}
            onChangeText={(t) => onChangeEmailAddress(t)}
            inputRef={textInputs.emailAddress}
            isInvalid={isInvalid.emailAddress}
            keyboardType='email-address'
            autoCapitalize='none'
            onSubmitEditing={() => onSubmitEditing('emailAddress')}
            returnKeyType='next'
            value={emailAddress}
            editable={!disabled.emailAddress}
          />
          {route.params.inviteType !== 'Quote'
          ?
            <>
              <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Mobile Phone Number</Text>
              <TextInputContainer
                iconName='phone'
                placeholder={`${contractorCustomerText2} Phone Number`}
                onChangeText={(t) => onChangePhoneNumber(t)}
                inputRef={textInputs.phoneNumber}
                isInvalid={isInvalid.phoneNumber}
                keyboardType='phone-pad'
                autoCompleteType='tel'
                textContentType="telephoneNumber"
                onSubmitEditing={() => onSubmitEditing('phoneNumber')}
                returnKeyType='done'
                value={phoneNumber}
                editable={!disabled.phoneNumber}
              />
            </>
          : null}
          
          {route.params.inviteType === 'Contractor' || route.params.inviteType === 'Quote' || ((route.params.inviteType === 'Create' || route.params.inviteType === 'Project')&& route.params.role === 'homeowner') ?
            <>
              <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Business Phone Number (Optional)</Text>
              <TextInputContainer
                iconName='phone'
                placeholder='Business Phone Number'
                onChangeText={(t) => onChangeBusinessNumber(t)}
                inputRef={textInputs.businessNumber}
                isInvalid={isInvalid.businessNumber}
                keyboardType='phone-pad'
                autoCompleteType='tel'
                textContentType="telephoneNumber"
                onSubmitEditing={previewInvitation}
                returnKeyType='done'
                value={businessNumber}
                editable={!disabled.businessNumber}
              />
            </>
          : null}

          {/* <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Personal Message</Text>
          <TextInputContainer
            placeholder='Any additional information you would like to pass along in the invitation'
            onChangeText={(t) => onChangePersonalMessage(t)}
            inputRef={textInputs.personalMessage}
            isInvalid={isInvalid.personalMessage}
            returnKeyType='done'
            value={personalMessage}
            editable={!disabled.personalMessage}
            multiline={true}
            numberOfLines={5}
            inputStyle={{ height: 120 }}
          /> */}
          
          {renderBottomBlurb(route.params.inviteType)}
        </View>
        {/* <View style={styles.smsEmailContainer}>
          {Platform.OS === 'web' ?
          null
          :
          <>
            <TouchableOpacity style={[styles.container, styles.containerLeft]} activeOpacity={0.6} onPress={() => sms()}>
              <MaterialIcons name="sms" size={85} color={Colors.blue} />
              <Text style={[CS.mediumText, CS.blueText, CS.boldText, CS.capsLock]}>Sms</Text>
            </TouchableOpacity>
            <TouchableOpacity style={[styles.container, Platform.OS === 'web' ? {} : styles.containerRight]} activeOpacity={0.6} onPress={() => email()}>
              <MaterialIcons name="mail" size={85} color={Colors.blue} />
              <Text style={[CS.mediumText, CS.blueText, CS.boldText, CS.capsLock]}>Email</Text>
            </TouchableOpacity>
          </>
          }
          
        </View> */}
        <View style={{ marginBottom: 10 }}>
          <Button text={Platform.OS === 'web' ? `Invite your ${contractorCustomerText2}` : 'Let us reach out'} onPress={() => previewInvitation} />
        </View>

        {/* <View style={{ marginBottom: 10 }}>
          <Button text='Test Preview' onPress={() => testShowPreview } />
        </View> */}
      {/* </ScrollView> */}
      </KeyboardAwareScrollView>
    </View>
  );

}

const styles = StyleSheet.create({
  scrollView: {
    // marginVertical: 10,
    ...Platform.select({
      ios: {
        width: '100%',
      },
      android: {
        width: '100%',
      }
    })
  },
  innerContainer: {
    width: '100%',
    // backgroundColor: 'pink',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    justifyContent: 'center',
    flexGrow: 1,
  },
  smsImg: {
    aspectRatio: 76 / 67,
    // marginBottom: 10,
  },
  emailImg: {
    aspectRatio: 77 / 49,
    // marginBottom: 10,
  },
  smsEmailContainer: {
    flexDirection: 'row',
  },
  // container: {
  //   flex:1,
  //   paddingVertical: 20,
  //   // paddingHorizontal: 40,
  //   alignItems:'center',
  //   backgroundColor: Colors.lightBlue2,
  //   borderRadius: 5,
  //   marginVertical: 20,
  // },
  // containerLeft: {
  //   marginRight:5,
  // },
  // containerRight: {
  //   marginLeft: 5,
  // },
  inputLabel: {
    marginBottom: 5,
  },
});

export default InviteScreen;